import { SVGProps } from 'react';

const ArrowUpDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m13 16 4 4 4-4m-4 4V4m-6 4L7 4 3 8m4-4v16"
    />
  </svg>
);
export default ArrowUpDown;
